import type { NavGroupSpec } from '@porotutu/react/components/Sidebar/navGroups'
import {
  ActivityIcon,
  Building2Icon,
  CoinsIcon,
  CreditCardIcon,
  GiftIcon,
  HistoryIcon,
  LayoutDashboardIcon,
  LayersIcon,
  ListChecksIcon,
  type LucideIcon,
  MegaphoneIcon,
  PackageIcon,
  ShieldCheckIcon,
  ShoppingCartIcon,
  SlidersHorizontalIcon,
  TrophyIcon,
  UserRoundIcon,
  UsersIcon,
  WebhookIcon,
} from 'lucide-react'

export const NAV_GROUPS: readonly NavGroupSpec[] = [
  { key: 'overview', slices: ['dashboard'] },
  {
    key: 'loyalty',
    slices: [
      'customers',
      'vouchers',
      'campaigns',
      {
        slice: 'point_transactions',
        path: '/point-transactions',
        labelKey: 'layouts.main.nav_point_transactions',
      },
      'orders',
      'redemptions',
      'events',
    ],
  },
  {
    key: 'loyalty_setup',
    slices: [
      'rewards',
      {
        slice: 'earning_rules',
        path: '/earning-rules',
        labelKey: 'layouts.main.nav_earning_rules',
      },
      'segments',
      'products',
      {
        slice: 'validation_rules',
        path: '/validation-rules',
        labelKey: 'layouts.main.nav_validation_rules',
      },
      {
        slice: 'webhook_subscriptions',
        path: '/webhook-subscriptions',
        labelKey: 'layouts.main.nav_webhook_subscriptions',
      },
    ],
  },
  {
    key: 'identity',
    slices: [
      'users',
      { slice: 'organizations', path: '/organization', labelKey: 'layouts.main.nav_organization' },
    ],
  },
  { key: 'oversight', slices: ['audit', 'jobs'] },
]

export const NAV_ICONS: Readonly<Record<string, LucideIcon>> = {
  dashboard: LayoutDashboardIcon,
  customers: UserRoundIcon,
  vouchers: CreditCardIcon,
  campaigns: MegaphoneIcon,
  point_transactions: CoinsIcon,
  orders: ShoppingCartIcon,
  redemptions: GiftIcon,
  events: ActivityIcon,
  rewards: TrophyIcon,
  earning_rules: SlidersHorizontalIcon,
  segments: LayersIcon,
  products: PackageIcon,
  validation_rules: ShieldCheckIcon,
  webhook_subscriptions: WebhookIcon,
  users: UsersIcon,
  organizations: Building2Icon,
  audit: HistoryIcon,
  jobs: ListChecksIcon,
}
